'use strict';

var _regeneratorRuntime = require("/Users/edtsech/code/projects/duonote/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator['throw'](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};

Object.defineProperty(exports, '__esModule', {
  value: true
});

var adaptor_1 = __importDefault(require('../adaptor'));

var ref_1 = require('../ref');

var doc_1 = require('../doc');

var data_1 = require('../data');
/**
 * Performs transaction.
 *
 * ```ts
 * import { transaction, collection } from 'typesaurus'
 *
 * type Counter = { count: number }
 * const counters = collection<Counter>('counters')
 *
 * transaction(async ({ get, set, update, remove }) => {
 *   const { data: { count } } = await get('420')
 *   await set(counter, { count: count + 1 })
 * })
 * ```
 *
 * @param transactionFn - The transaction body function that accepts transaction API
 * @returns Promise that is resolved when transaction is closed
 */


function transaction(transactionFn) {
  return adaptor_1.default().runTransaction(function (t) {
    /**
     * Retrieves a document from a collection.
     *
     * ```ts
     * import { transaction, collection } from 'typesaurus'
     *
     * type Counter = { count: number }
     * const counters = collection<Counter>('counters')
     *
     * transaction(async ({ get, set }) => {
     *   const counter = await get('420')
     *   //=> { __type__: 'doc', data: { count: 42 }, ... }
     *   await set(counter.ref, { count: counter.data.count + 1 })
     * })
     * ```
     *
     * @returns Promise to the document or undefined if not found
     */
    function get(collectionOrRef, maybeId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var collection, id, ref, firestoreDoc, firestoreSnap, firestoreData, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (collectionOrRef.__type__ === 'collection') {
                  collection = collectionOrRef;
                  id = maybeId;
                } else {
                  ref = collectionOrRef;
                  collection = ref.collection;
                  id = ref.id;
                }

                firestoreDoc = adaptor_1.default().collection(collection.path).doc(id); // ^ above
                // TODO: Refactor code above and below because is all the same as in the regular get function

                _context.next = 4;
                return t.get(firestoreDoc);

              case 4:
                firestoreSnap = _context.sent;
                // v below
                firestoreData = firestoreSnap.data();
                data = firestoreData && data_1.wrapData(firestoreData);
                return _context.abrupt("return", data ? doc_1.doc(ref_1.ref(collection, id), data) : undefined);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Sets a document to the given data.
     *
     * ```ts
     * import { transaction, collection } from 'typesaurus'
     *
     * type Counter = { count: number }
     * const counters = collection<Counter>('counters')
     *
     * transaction(async ({ get, set }) => {
     *   const counter = await get('420')
     *   await set(counter.ref, { count: counter.data.count + 1 })
     *   //=> { __type__: 'doc', data: { count: 43 }, ... }
     * })
     * ```
     *
     * @returns A promise to the document
     */


    function set(collectionOrRef, idOrData, maybeData) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var collection, id, data, ref, firestoreDoc;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (collectionOrRef.__type__ === 'collection') {
                  collection = collectionOrRef;
                  id = idOrData;
                  data = maybeData;
                } else {
                  ref = collectionOrRef;
                  collection = ref.collection;
                  id = ref.id;
                  data = idOrData;
                }

                firestoreDoc = adaptor_1.default().collection(collection.path).doc(id); // ^ above
                // TODO: Refactor code above and below because is all the same as in the regular set function

                _context2.next = 4;
                return t.set(firestoreDoc, data_1.unwrapData(data));

              case 4:
                return _context2.abrupt("return", doc_1.doc(ref_1.ref(collection, id), data));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Updates a document.
     *
     * ```ts
     * import { transaction, field, collection } from 'typesaurus'
     *
     * type Counter = { count: number }
     * const counters = collection<Counter>('counters')
     *
     * transaction(async ({ get, set }) => {
     *   const counter = await get('420')
     *   await update(counter.ref, { count: counter.data.count + 1 })
     *   //=> { __type__: 'doc', data: { count: 43 }, ... }
     *   // Or using field paths:
     *   await update(users, '00sHm46UWKObv2W7XK9e', [
     *     field('name', 'Sasha Koss'),
     *     field(['address', 'city'], 'Moscow')
     *   ])
     * })
     * ```
     *
     * @returns A promise that resolves when operation is finished
     */


    function update(collectionOrRef, idOrData, maybeData) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var collection, id, data, ref, firebaseDoc, updateData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (collectionOrRef.__type__ === 'collection') {
                  collection = collectionOrRef;
                  id = idOrData;
                  data = maybeData;
                } else {
                  ref = collectionOrRef;
                  collection = ref.collection;
                  id = ref.id;
                  data = idOrData;
                }

                firebaseDoc = adaptor_1.default().collection(collection.path).doc(id);
                updateData = Array.isArray(data) ? data.reduce(function (acc, _ref) {
                  var key = _ref.key,
                      value = _ref.value;
                  acc[Array.isArray(key) ? key.join('.') : key] = value;
                  return acc;
                }, {}) : data; // ^ above
                // TODO: Refactor code above because is all the same as in the regular update function

                _context3.next = 5;
                return t.update(firebaseDoc, data_1.unwrapData(updateData));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * Removes a document.
     *
     * ```ts
     * import { transaction, field, collection } from 'typesaurus'
     *
     * type Counter = { count: number }
     * const counters = collection<Counter>('counters')
     *
     * transaction(async ({ get, remove }) => {
     *   const counter = await get('420')
     *   if (counter === 420) await remove(counter.ref)
     * })
     * ```
     *
     * @returns Promise that resolves when the operation is complete.
     */


    function remove(collectionOrRef, maybeId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var collection, id, ref, firebaseDoc;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (collectionOrRef.__type__ === 'collection') {
                  collection = collectionOrRef;
                  id = maybeId;
                } else {
                  ref = collectionOrRef;
                  collection = ref.collection;
                  id = ref.id;
                }

                firebaseDoc = adaptor_1.default().collection(collection.path).doc(id); // ^ above
                // TODO: Refactor code above because is all the same as in the regular update function

                _context4.next = 4;
                return t.delete(firebaseDoc);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }

    return transactionFn({
      get: get,
      set: set,
      update: update,
      remove: remove,
      clear: remove
    });
  });
}

exports.transaction = transaction;